import { NSMenuActionProps } from "namirasoft-site-react";

export class JobArrangerMenus
{
	static download(): NSMenuActionProps
	{
		return {
			id: "1",
			menu_item: "Download Extension",
			isActive: () =>
			{
				return true;
			},
			onClick: {
				action: () =>
				{
					let link = "https://chromewebstore.google.com/detail/job-arranger-linkedininde/paihdpncghiaifanpfaddgaphjdaijbo?hl=en&authuser=0";
					window.open(link, "_open");
				},
				showLoading: false
			}
		}
	}
}